var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form calculation-popup"
  }, [_c('div', {
    staticClass: "content-form-popup calculation-popup__content"
  }, [_c('div', {
    staticClass: "header-text calculation-popup__header"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": "Zavrieť"
    }
  })]), _c('div', [_c('div', {
    staticClass: "calculation-popup__eyebrow"
  }, [_vm._v("Vysvetlenie bankovej ponuky")]), _c('h2', {
    staticClass: "calculation-popup__title"
  }, [_vm._v(" Ako "), _c('span', {
    staticClass: "primary"
  }, [_vm._v(_vm._s(_vm.bankName))]), _vm._v(" vypočítala ponuku ")])])]), _vm.hasCalculationTrace ? [_c('section', {
    staticClass: "offer-overview"
  }, [_c('div', {
    staticClass: "offer-overview__item"
  }, [_c('span', [_vm._v("Výška úveru")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.offer.pozicana_suma)))])]), _c('div', {
    staticClass: "offer-overview__item"
  }, [_c('span', [_vm._v("Mesačná splátka")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.offer.mesacna_splatka, 2)))])]), _c('div', {
    staticClass: "offer-overview__item"
  }, [_c('span', [_vm._v("Sadzba / fixácia")]), _c('strong', [_vm._v(_vm._s(_vm.number(_vm.offer.sadzba, 2)) + " % / " + _vm._s(_vm.offer.fix) + " r.")])]), _c('div', {
    staticClass: "offer-overview__item"
  }, [_c('span', [_vm._v("Splatnosť")]), _c('strong', [_vm._v(_vm._s(_vm.offer.splatnost_r) + " rokov")])]), _vm.offerLtv !== null ? _c('div', {
    staticClass: "offer-overview__item"
  }, [_c('span', [_vm._v("LTV ponuky")]), _c('strong', [_vm._v(_vm._s(_vm.number(_vm.offerLtv, 2)) + " %")])]) : _vm._e()]), _c('section', {
    staticClass: "calculation-section"
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_vm._m(0), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.trace.akceptovane_prijmy_mo, 2)) + " / mes.")])]), _c('p', {
    staticClass: "section-description"
  }, [_vm._v(" Ide o mesačné príjmy, ktoré banka po vlastnom metodickom krátení použila najmä vo výpočte DSTI. ")]), _c('client-dti-info-card', {
    attrs: {
      "incomes": _vm.applicantIncomeRows,
      "role": "applicant"
    }
  }), _c('client-dti-info-card', {
    attrs: {
      "incomes": _vm.coApplicantIncomeRows,
      "role": "coapplicant"
    }
  }), _vm.incomeRows.length === 0 ? _c('div', {
    staticClass: "empty-note"
  }, [_vm._v(" V ponuke nie je dostupný rozpis jednotlivých príjmov. ")]) : _vm._e()], 1), _c('section', {
    staticClass: "calculation-section"
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_vm._m(1), _c('strong', [_vm._v("maximum " + _vm._s(_vm.money(_vm.trace.maximalna_nova_splatka_mo, 2)))])]), _c('div', {
    staticClass: "formula-list"
  }, [_c('div', {
    staticClass: "formula-row"
  }, [_c('div', {
    staticClass: "formula-row__number"
  }, [_vm._v("1")]), _vm._m(2), _c('strong', {
    staticClass: "formula-row__value"
  }, [_vm._v(_vm._s(_vm.money(_vm.trace.akceptovane_prijmy_mo, 2)))])]), _c('div', {
    staticClass: "formula-row"
  }, [_c('div', {
    staticClass: "formula-row__number"
  }, [_vm._v("2")]), _c('div', {
    staticClass: "formula-row__copy"
  }, [_c('strong', [_vm._v("Odpočet životného minima domácnosti")]), _c('span', [_vm._v(_vm._s(_vm.lifeMinimumExplanation))])]), _c('strong', {
    staticClass: "formula-row__value formula-row__value--minus"
  }, [_vm._v("− " + _vm._s(_vm.money(_vm.trace.zivotne_minimum_mo, 2)))])]), _c('div', {
    staticClass: "formula-row formula-row--subtotal"
  }, [_c('div', {
    staticClass: "formula-row__number"
  }, [_vm._v("=")]), _c('div', {
    staticClass: "formula-row__copy"
  }, [_c('strong', [_vm._v("Príjem po odpočítaní životného minima")]), _c('span', [_vm._v(_vm._s(_vm.money(_vm.trace.akceptovane_prijmy_mo, 2)) + " − " + _vm._s(_vm.money(_vm.trace.zivotne_minimum_mo, 2)))])]), _c('strong', {
    staticClass: "formula-row__value"
  }, [_vm._v(_vm._s(_vm.money(_vm.trace.prijem_po_odcitani_zivotneho_minima_mo, 2)))])]), _c('div', {
    staticClass: "formula-row"
  }, [_c('div', {
    staticClass: "formula-row__number"
  }, [_vm._v("3")]), _c('div', {
    staticClass: "formula-row__copy"
  }, [_c('strong', [_vm._v(_vm._s(_vm.number(_vm.trace.dsti_percenta_z_prijmu, 0)) + " % zo zostávajúceho príjmu")]), _c('span', [_vm._v("Maximálna časť príjmu, ktorú možno použiť na všetky mesačné splátky.")])]), _c('strong', {
    staticClass: "formula-row__value"
  }, [_vm._v(_vm._s(_vm.money(_vm.trace.limit_na_vsetky_splatky_mo, 2)))])]), _c('div', {
    staticClass: "formula-row"
  }, [_c('div', {
    staticClass: "formula-row__number"
  }, [_vm._v("4")]), _c('div', {
    staticClass: "formula-row__copy"
  }, [_c('strong', [_vm._v("Odpočet existujúcich záväzkov")]), _vm.trace.stresovany_vypocet && _vm.positive(_vm.trace.existujuce_splatky_mo) ? _c('span', [_vm._v(" Evidované splátky " + _vm._s(_vm.money(_vm.trace.existujuce_splatky_mo, 2)) + " banka zvýšila o " + _vm._s(_vm.number(_vm.trace.stres_existujucich_splatok_percent, 0)) + " % na " + _vm._s(_vm.money(_vm.trace.existujuce_splatky_po_strese_mo, 2)) + ". ")]) : _vm.positive(_vm.trace.existujuce_splatky_mo) ? _c('span', [_vm._v(" Súčet mesačných splátok aktívnych záväzkov. ")]) : _c('span', [_vm._v("Vo výpočte nie sú odpočítané žiadne existujúce splátky.")])]), _c('strong', {
    staticClass: "formula-row__value formula-row__value--minus"
  }, [_vm._v("− " + _vm._s(_vm.money(_vm.trace.existujuce_splatky_po_strese_mo, 2)))])]), _vm.debtRows.length ? _c('div', {
    staticClass: "debt-breakdown"
  }, _vm._l(_vm.debtRows, function (debt) {
    return _c('div', {
      key: "".concat(debt.role, "-").concat(debt.id),
      staticClass: "debt-breakdown__item"
    }, [_c('div', [_c('span', [_vm._v(_vm._s(debt.role === "applicant" ? "Žiadateľ" : "Spolužiadateľ"))]), _c('strong', [_vm._v(_vm._s(debt.type))])]), _c('div', [_c('span', [_vm._v("Mesačná splátka")]), _c('strong', [_vm._v(_vm._s(_vm.money(debt.monthlyPayment, 2)))])]), debt.balance !== null ? _c('div', [_c('span', [_vm._v("Záväzok pre DTI")]), _c('strong', [_vm._v(_vm._s(_vm.money(debt.balance)))])]) : _vm._e()]);
  }), 0) : _vm._e(), _c('div', {
    staticClass: "formula-result"
  }, [_c('div', [_c('span', [_vm._v("Maximálna nová mesačná splátka podľa DSTI")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.trace.maximalna_nova_splatka_mo, 2)))])]), _c('div', [_c('span', [_vm._v("Splátka tejto ponuky")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.offer.mesacna_splatka, 2)))])]), _c('div', {
    "class": {
      'formula-result__warning': _vm.paymentReserve < 0
    }
  }, [_c('span', [_vm._v("Rezerva do DSTI limitu")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.paymentReserve, 2)))])])])])]), _vm.loanLimits.length ? _c('section', {
    staticClass: "calculation-section"
  }, [_c('div', {
    staticClass: "section-heading"
  }, [_vm._m(3), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.maxLoanValue)))])]), _c('p', {
    staticClass: "section-description"
  }, [_vm._v(" DSTI určuje dostupnú mesačnú splátku. Banka ju následne porovná s kontrolným limitom DTI, LTV a obmedzeniami účelu; maximum zodpovedá najnižšiemu výsledku. ")]), _c('div', {
    staticClass: "limit-list"
  }, _vm._l(_vm.loanLimits, function (limit) {
    return _c('div', {
      key: limit.key,
      staticClass: "limit-row",
      "class": {
        'limit-row--active': limit.active
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(limit.label))]), _c('span', [_vm._v(_vm._s(limit.description))])]), _c('div', {
      staticClass: "limit-row__value"
    }, [limit.active ? _c('span', [_vm._v("Limitujúci faktor")]) : _vm._e(), _c('strong', [_vm._v(_vm._s(_vm.money(limit.value)))])])]);
  }), 0)]) : _vm._e(), _vm.calculationParameters.length ? _c('section', {
    staticClass: "calculation-section calculation-section--compact"
  }, [_vm._m(4), _c('div', {
    staticClass: "parameter-grid"
  }, _vm._l(_vm.calculationParameters, function (parameter) {
    return _c('div', {
      key: parameter.label,
      staticClass: "parameter-card"
    }, [_c('span', [_vm._v(_vm._s(parameter.label))]), _c('strong', [_vm._v(_vm._s(parameter.value))])]);
  }), 0)]) : _vm._e(), _c('section', {
    staticClass: "calculation-section calculation-summary"
  }, [_vm._m(5), _c('div', {
    staticClass: "summary-context"
  }, [_c('div', [_c('span', [_vm._v("Domácnosť")]), _c('strong', [_vm._v(_vm._s(_vm.householdComposition))])]), _c('div', [_c('span', [_vm._v("Životné minimum")]), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.trace.zivotne_minimum_mo, 2)))]), _c('small', [_vm._v(_vm._s(_vm.lifeMinimumExplanation))])]), _c('div', [_c('span', [_vm._v("Celková splatnosť")]), _c('strong', [_vm._v(_vm._s(_vm.summaryMaturity))])]), _c('div', [_c('span', [_vm._v("Sadzba použitá pre DSTI")]), _c('strong', [_vm._v(_vm._s(_vm.summaryStressedRate))])])]), _c('div', {
    staticClass: "summary-formula"
  }, [_c('span', [_vm._v(" (" + _vm._s(_vm.money(_vm.trace.akceptovane_prijmy_mo, 2)) + " − " + _vm._s(_vm.money(_vm.trace.zivotne_minimum_mo, 2)) + ") × " + _vm._s(_vm.number(_vm.trace.dsti_percenta_z_prijmu, 0)) + " % − " + _vm._s(_vm.money(_vm.trace.existujuce_splatky_po_strese_mo, 2)) + " ")]), _c('strong', [_vm._v("= " + _vm._s(_vm.money(_vm.trace.maximalna_nova_splatka_mo, 2)) + " maximálna nová splátka")])]), _vm.dstiLoanLimit ? _c('p', {
    staticClass: "summary-explanation"
  }, [_vm._v(" Pri splatnosti " + _vm._s(_vm.summaryMaturity) + " a stresovej sadzbe " + _vm._s(_vm.summaryStressedRate) + " zodpovedá táto dostupná splátka maximálnemu úveru "), _c('strong', [_vm._v(_vm._s(_vm.money(_vm.dstiLoanLimit.value)))]), _vm._v(" podľa DSTI. ")]) : _vm._e(), _c('div', {
    staticClass: "summary-decision",
    "class": {
      'summary-decision--dsti': _vm.dstiIsLimiting
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dstiIsLimiting ? "Určujúci limit" : "Vyhodnotenie ponuky"))]), _c('strong', [_vm._v(_vm._s(_vm.summaryDecisionTitle))]), _c('p', [_vm._v(_vm._s(_vm.summaryDecisionText))])])]), _c('div', {
    staticClass: "calculation-note"
  }, [_vm._v(" Výpočet je informatívny a vychádza z údajov evidovaných v tejto hypotéke a z aktuálne nastavenej metodiky banky. Konečné posúdenie vykonáva banka. ")])] : _vm.traceLoading ? [_c('section', {
    staticClass: "calculation-section trace-loading"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner small transparent",
    attrs: {
      "indeterminate": ""
    }
  }), _vm._m(6)], 1)] : [_c('section', {
    staticClass: "calculation-section"
  }, [_vm._m(7), _c('client-dti-info-card', {
    attrs: {
      "incomes": _vm.legacyIncomeRows.applicant,
      "role": "applicant"
    }
  }), _c('client-dti-info-card', {
    attrs: {
      "incomes": _vm.legacyIncomeRows.coApplicant,
      "role": "coapplicant"
    }
  }), _vm.traceLoadFailed ? _c('div', {
    staticClass: "empty-note"
  }, [_vm._v(" API tejto ponuky nevrátilo životné minimum alebo súčet existujúcich splátok. Bez týchto operandov nie je možné zostaviť presný DSTI vzorec. ")]) : _vm._e()], 1)]], 2)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('span', {
    staticClass: "section-heading__index"
  }, [_vm._v("01")]), _c('h3', [_vm._v("Akceptované príjmy")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('span', {
    staticClass: "section-heading__index"
  }, [_vm._v("02")]), _c('h3', [_vm._v("DSTI krok za krokom")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "formula-row__copy"
  }, [_c('strong', [_vm._v("Akceptované čisté príjmy domácnosti")]), _c('span', [_vm._v("Súčet vyššie uvedených príjmov po metodickom krátení banky.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('span', {
    staticClass: "section-heading__index"
  }, [_vm._v("03")]), _c('h3', [_vm._v("Čo obmedzilo maximálnu výšku úveru")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-heading"
  }, [_c('div', [_c('span', {
    staticClass: "section-heading__index"
  }, [_vm._v("04")]), _c('h3', [_vm._v("Parametre metodiky banky")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-heading"
  }, [_c('div', [_c('span', {
    staticClass: "section-heading__index"
  }, [_vm._v("05")]), _c('h3', [_vm._v("Sumárny vzorec a záver")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('strong', [_vm._v("Načítavam presný DSTI výpočet")]), _c('span', [_vm._v("Ponuku prepočítavam s rovnakou bankou, fixáciou a splatnosťou.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "section-heading"
  }, [_c('div', [_c('span', {
    staticClass: "section-heading__index"
  }, [_vm._v("01")]), _c('h3', [_vm._v("Akceptované príjmy")])])]);

}]

export { render, staticRenderFns }